/* eslint-disable @typescript-eslint/no-unused-vars */
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import { IScopeValue } from '.';
import {
  messageError,
  messageSuccess,
} from '../../../../../components/message';
import getFormatMessage from '../../../../../locales/get-format-message';
import {
  IGCloudSdkItem,
  INoticeSystemScopeResult,
} from '../../../../../model/api-modules';
import { FilterType } from './drawer';

export const getFilterTitle = (
  condition: {
    type?: string;
    condition?: Object;
  } = {}
) => {
  let tip = '';
  if (condition.type === FilterType.GameID) {
    const searchValues = condition.condition as string[];
    tip += `GameID: ${
      searchValues.join(', ') || getFormatMessage('notice_select_all')
    }`;
  }
  if (condition.type === FilterType.GcloudVersion) {
    const searchValues = condition.condition as string[];
    tip += `​​${getFormatMessage('notice_gcloud_ver')}: ${
      searchValues.join(', ') || getFormatMessage('notice_select_all')
    }`;
  }
  if (condition.type === FilterType.SdkVersion) {
    const searchValues = condition.condition as IGCloudSdkItem[];
    tip += `${getFormatMessage('notice_component_ver')}: ${
      searchValues
        .map((item) => `${item.sdkName}/${item.sdkVersion}`)
        .join(', ') || getFormatMessage('notice_select_all')
    }`;
  }

  return {
    title: getFormatMessage('notice_xlsx_title'),
    content: tip,
  };
};

export const downloadXlsx = async (scopeInfo?: IScopeValue) => {
  if (!scopeInfo) {
    return;
  }
  try {
    const titleInfo = getFilterTitle(scopeInfo.condition);
    const extraInfo = [
      `*${getFormatMessage('notice_xlsx_total_info', {
        params: {
          total: scopeInfo.result.length + scopeInfo.notSelected.length,
          selectedCount: scopeInfo.result.length,
        },
      })}`,
    ];
    const tip = {
      richText: [
        { text: `${titleInfo.title}\n` },
        {
          text: `${titleInfo.content}\n`,
        },
        { text: `${extraInfo[0]}`, font: { color: { argb: 'FFFF0000' } } },
      ],
    };

    // 创建测试数据
    const head = [
      '序号',
      getFormatMessage('notice_game_selected'),
      'GameID',
      'Game Name',
      getFormatMessage('notice_kpi_binding'),
      getFormatMessage('notice_xlsx_member'),
    ];

    const getBody = (
      resList: readonly INoticeSystemScopeResult[],
      isSelected: boolean,
      startIndex = 1
    ) => {
      return resList
        .map((noticeItem, index) => {
          const commonColumns = [
            index + startIndex,
            isSelected ? getFormatMessage('yes') : getFormatMessage('no'),
            noticeItem.gameID,
            noticeItem.gameName,
            noticeItem.isBindKpiCode
              ? getFormatMessage('yes')
              : getFormatMessage('no'),
          ];
          return [
            [
              ...commonColumns,
              `${getFormatMessage(
                'notice_xlsx_admin'
              )}: ${noticeItem.adminMembers.join()}`,
            ],
            [
              ...commonColumns,
              `${getFormatMessage('notice_xlsx_other')}: ${noticeItem.members
                .filter((item) => !noticeItem.adminMembers.includes(item))
                .join()}`,
            ],
          ];
        })
        .flat();
    };

    const body = [
      ...getBody(scopeInfo.result, true),
      [],
      [],
      ...getBody(scopeInfo.notSelected, false, scopeInfo.result.length + 1),
    ];

    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet('Sheet1');

    worksheet.getCell('A1').value = tip;
    worksheet.mergeCells('A1:F1');
    worksheet.addRow(head);
    worksheet.addRows(body);

    worksheet.getRow(1).height = 45;
    worksheet.getRow(1).getCell(1).alignment = {
      wrapText: true,
      vertical: 'middle',
    };
    worksheet.getColumn('B').width = 15;
    worksheet.getColumn('C').width = 15;
    worksheet.getColumn('D').width = 20;
    worksheet.getColumn('E').width = 17;
    worksheet.getColumn('F').width = 120;
    worksheet.getColumn('F').alignment = { wrapText: true };

    body.forEach((row, index) => {
      if (!row[0]) {
        return;
      }
      if (index % 2 === 0) {
        const mergeStartRow = index + 3;
        worksheet.mergeCells(`A${mergeStartRow}:A${mergeStartRow + 1}`);
        worksheet.mergeCells(`B${mergeStartRow}:B${mergeStartRow + 1}`);
        worksheet.mergeCells(`C${mergeStartRow}:C${mergeStartRow + 1}`);
        worksheet.mergeCells(`D${mergeStartRow}:D${mergeStartRow + 1}`);
        worksheet.mergeCells(`E${mergeStartRow}:E${mergeStartRow + 1}`);
      }
    });

    // 导出为 Blob 并触发下载
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);

    // 创建下载链接
    const a = document.createElement('a');
    a.href = url;
    a.download = `${getFormatMessage(
      'notice_xlsx_filename_prefix'
    )}_${moment().format('YYYYMMDDHHmmss')}.xlsx`; // 设置文件名
    a.click();

    // 释放内存
    URL.revokeObjectURL(url);

    messageSuccess(getFormatMessage('notice_xlsx_success'));
  } catch (err) {
    messageError(getFormatMessage('notice_xlsx_fail'));
  }
};
